const tabClick            = ({ target }) => {
	const { dataset: { id = '' }} = target;
	document.querySelectorAll( '.our-offer__tab' ).forEach( t => t.classList.remove( 'our-offer__tab--active' ) );
	target.classList.add( 'our-offer__tab--active' );
	document.querySelectorAll( '.our-offer__results' ).forEach( t => t.classList.remove( 'our-offer__results--active' ) );
	document.querySelector( `#${id}` ).classList.add( 'our-offer__results--active' );
};

const bindTabs = () => {
	document.querySelectorAll( '.our-offer__tab' ).forEach(
		tab => {
			tab.addEventListener( 'click', tabClick );
		}
	)
};

document.addEventListener(
	'DOMContentLoaded',
	() => {
		bindTabs();
	}
);
